<template>
    <div class="view stores">
        <div class="action-header">
            <DateRangeFilterClusters
                    @selectedRange="selectDateRange"
                    />  
            <button v-if="loaded" v-on:click="csvExport" class="button white sm">
                    <i class="icon ico-download"></i>
                <p>Descargar tabla</p>
            </button >
        </div>
        <!-- <TableCard
            title="Performance por cluster"
            :sub="rangeTitle"
            @openModal="showModal"
            :data="allClusters"
            :titles="[
                {'name': 'Cluster', 'order': false, 'field': 'name'},
                {'name': 'Cantidad de sucursales', 'order': false, 'field': 'clusters'},
                {'name': 'Conexiones', 'order': false, 'field': 'totalConections'},
                {'name': 'Visitantes', 'order': false, 'field': 'visitantes'},
                {'name': 'Transeúntes', 'order': false, 'field': 'transeuntes'},
                {'name': 'Promedio conexiones', 'order': false, 'field': 'conexiones_prom'},
                {'name': 'Promedio visitantes', 'order': false, 'field': 'recurrents_prom'},
                {'name': 'Promedio transeúntes', 'order': false, 'field': 'not_recurrents_prom'},
                {'name': 'Revenue por contenidos', 'order': false, 'field': 'revenue'},
                {'name': 'Interacciones con contenidos', 'order': false, 'field': 'clicks'}
            ]"
            :hide="true"
            :loader="loaded"
            /> -->

            <TableCard
                title="Performance por cluster"
                :sub="rangeTitle"
                @openModal="showModal"
                :data="clusterData"
                :titles="[
                    {'name': 'Cluster', 'order': false, 'field': 'name'},
                    {'name': 'Cantidad de sedes', 'order': false, 'field': 'clusters'},
                    {'name': 'Conexiones', 'order': false, 'field': 'totalConections'},
                    {'name': 'Visitantes', 'order': false, 'field': 'visitantes'},
                    {'name': 'Transeúntes', 'order': false, 'field': 'transeuntes'},
                    {'name': 'Promedio conexiones', 'order': false, 'field': 'conexiones_prom'},
                    {'name': 'Promedio visitantes', 'order': false, 'field': 'recurrents_prom'},
                    {'name': 'Promedio transeúntes', 'order': false, 'field': 'not_recurrents_prom'}
                ]"
                :hide="true"
                :loader="loaded"
                />
        <div class="header">
            <h5 class="section-title">
                Clusters
            </h5>
        </div>

        <transition name="expand">
            <ClusterCard v-if="clusterActive"
                class="clustercard"
                :sub="rangeTitle"
                :cluster="clusterActive.name"
                :venues="clusterActive.clusters"
                :averageConnections="clusterActive.conexiones_prom"
                :averageVisitors="clusterActive.recurrents_prom"
                :averagePasserby="clusterActive.not_recurrents_prom"
                :totalVisitors="clusterActive.visitantes"
                :totalPasserby="clusterActive.transeuntes"
                :totalConnections="clusterActive.totalConections"
                :totalInteractions="clusterActive.clicks"
                @hideCluster="selectCluster"
                :stores="clusterActive.stores"
                :totalRevenue="clusterActive.revenue"
                :data="clusterActive.barChartData"
                :periodItems="clusterActive.periodBarChartData"
                :dataLine="clusterActive.connectionLineChart"
                :periodItemsLine="clusterActive.periodLineChartData"
                :loader="loaded"
                />
        </transition>
        <div class="cluster-list">
            <div class="minichart" v-for="(item,key) in clusterData" :key="key">
                <transition name="fade" >
                    <MiniLineChartCard 
                    :cluster="item.name"
                    :venues="item.clusters"
                    :totalRevenue="item.totalConections"
                    :id="item.id"
                    :data="item.connectionLineChart"
                    :periodItems="item.periodLineChartData"
                    :activeId="clusterActive ? clusterActive.id : null"
                    @selectCluster="selectCluster"
                    :loader="loadedOffersData"
                    />
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import _default, { mapActions, mapGetters } from 'vuex'
import DeviceNotAllowed from "@/components/DeviceNotAllowed"
import TableCard from '@/components/cards/TableCard'
import MapCard from '@/components/cards/MapCard'
import StoreModal from '@/components/modals/StoreModal'
import DateRangeFilterClusters from "@/components/DateRangeFilterClusters"
import MiniLineChartCard from "@/components/cards/MiniLineChartCard"
import ClusterCard from "@/components/cards/ClusterCard"
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

export default {
    name: 'Stores',
    data: function(){
        return {
            search_text: '',
            list: false,
            storeModal: false,
            storeForModal: {},
            initRange: moment().subtract(7,'d').format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'd').format('YYYY-MM-DD'),
            store_id: '999999',
            loaded: false,
            loadedOffersData: false,
            clusterArray: [],
            selectedCluster: "",
            selectedClusterVenues: "",
            clusterActive: null,
            clusterData: []
        }
    },
    components: {
        TableCard,
        MapCard,
        DeviceNotAllowed,
        StoreModal,
        DateRangeFilterClusters,
        MiniLineChartCard,
        ClusterCard,
    },
    created: function(){
        this.$store.dispatch("auth/setActive", "clusters");
        this.getClusters().then(r => {
                this.clusterArray = this.getAllClusters
                // this.getSessions();
                this.getClusterSession()
                
            }, err => {
                console.log(err)
            })
    },
    methods: {
        thousandseparatos: function(num){
            
            try {
                let num_parts = []
                num = parseInt(num)
                if (num > 999999){
                    num = ((num / 1000000).toFixed(1))
                    num_parts = num.toString().split(".");
                    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    num_parts = num_parts.join(".");
                    num_parts = num_parts+" MM"
                }else{
                    num_parts = num.toString().split(".");
                    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    num_parts = num_parts.join(".");
                }

                return num_parts
            } catch (error) {
                return error
            }
        },
        csvExport: function() {

            let clustersToExport = this.clusterArray

            let periodRecurrentNotrecurrent = []

            _.each(clustersToExport, (cluster, csindex) => {
                let spaceperiod = {}
                spaceperiod["Cluster"] = cluster.name
                spaceperiod["Sedes"] = this.thousandseparatos(cluster.clusters)
                spaceperiod["Conexiones"] = this.thousandseparatos(cluster.totalConections)
                spaceperiod["Visitantes"] = this.thousandseparatos(cluster.visitantes)
                spaceperiod["Transeúntes"] = this.thousandseparatos(cluster.transeuntes)
                spaceperiod["Promedio conexiones"] = this.thousandseparatos(cluster.conexiones_prom)
                spaceperiod["Promedio visitantes"] = this.thousandseparatos(cluster.recurrents_prom)
                spaceperiod["Promedio transeúntes"] = this.thousandseparatos(cluster.not_recurrents_prom)
                spaceperiod["Revenue por contenidos"] = this.thousandseparatos(cluster.revenue)
                spaceperiod["Interacciones por contenidos"] = this.thousandseparatos(cluster.clicks)
                
                periodRecurrentNotrecurrent.push(spaceperiod)
                
            })

            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
            Object.keys(periodRecurrentNotrecurrent[0]).join(";"),
            ...periodRecurrentNotrecurrent.map(item => Object.values(item).join(";"))
            ]
            .join("\n")
            .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", moment().format('DD-MM-YYYY')+"_Notros_Clusters.csv");
            link.click();
        },
        checkValue: function(value,arr){
            var status = false;
            
            for(var i=0; i<arr.length; i++){
                var name = arr[i];
                if(name == value){
                status = true;
                break;
                }
            }

            return status;
        },
        selectDateRange: function(value){
            this.initRange = value[0]
            this.getClusterSession();
        },
        filter_text: function(){
            this.setFilter(this.search_text)
        },
        controlStrings: function(data) {
            data = data.replace(/á/gi,"a");
            data = data.replace(/é/gi,"e");
            data = data.replace(/í/gi,"i");
            data = data.replace(/ó/gi,"o");
            data = data.replace(/ú/gi,"u");
            data = data.replace(/ñ/gi,"n");
            return data.toLowerCase()
        },
        showModal: function(id) {
            // console.log(this.getCluster(id))
            this.selectedCluster = this.getCluster(id)[0].name
            this.selectedClusterVenues = this.getCluster(id)[0].clusters
        },
        ...mapActions('stores', {
            'getStores': 'storeRequest',
            'setFilter': 'setFilter'
        }),
        ...mapActions('clusters', {
            'getClusters': 'clusterRequest',
            'setClusterFilter': 'setClusterFilter'
        }),
        // Recurso para obtener sesiones x cluster
        // 
        apiSessionxCluster: async function(clusterId, initDate, endDate){
            let headers = {
                "Authorization": "ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6",
                "Access-Control-Allow-Origin": "*"
            }
            let total = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions/cluster/"+clusterId+"/?init_date="+initDate+"&end_date="+endDate, { headers : headers })
            
            let sumConnection = _.sumBy(total.data, function(day){
                return day["not_customer"] + day["customer"]
            }) 
            let periodArray = []
            let periodValue = []
            _.each(total.data, function(period){
                periodArray.push(period["period"])
                periodValue.push(period["not_customer"]+ period["customer"])
            })
            let response = [{
                sumConnection: sumConnection,
                periodArray: periodArray,
                periodValue: periodValue
            }]
            return response;
        },
        // apiVisitorsxCluster
        // Funcion para obtner el total de visitantes agrupados por cluster
        apiVisitorsxCluster: async function(clusterId, initDate, endDate){
            let headers = {
                "Authorization": "ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6",
                "Access-Control-Allow-Origin": "*"
            }
            let total = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/cluster/visitors/?init_date="+initDate+"&end_date="+endDate+"&cluster_id="+clusterId, { headers : headers })

            let sumVisitors = _.sumBy(total.data, function(day){
                return day["value"]
            })
            return sumVisitors           
        },
        // apiPasserByxCluster
        // Funcion para obtener información de passer by agrupadas por cluster
        apiPasserByxCLuster: async function(clusterId, initDate, endDate){
            let headers = {
                "Authorization": "ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6",
                "Access-Control-Allow-Origin": "*"
            }
            let total = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/cluster/passer_by/?init_date="+initDate+"&end_date="+endDate+"&cluster_id="+clusterId, { headers : headers })

            let sumPasserBy = _.sumBy(total.data, function(day){
                return day["value"]
            })
            return sumPasserBy  
        },
        getClusterSession: function(){
            // this.loaded = true
            // this.loadedOffersData = true
            let initDate = this.initRange
            let endDate = this.yesterday
            let clusterDataSet = [];
            
            let done = _.each(this.clusterArray, async (cluster) => {
                let connections = await this.apiSessionxCluster(cluster["id"], initDate, endDate)  
                let visitors = await this.apiVisitorsxCluster(cluster["id"], initDate, endDate)  
                let passerBy = await this.apiPasserByxCLuster(cluster["id"], initDate, endDate)
                let lineChartData = [{
                    'name': 'Conexiones',
                    'data': connections[0]["periodValue"]
                }, ]
                clusterDataSet.push({
                    "id": cluster["id"],
                    "name": cluster["name"], 
                    "clusters": cluster["stores"].length, 
                    "totalConections": connections[0]["sumConnection"],
                    "visitantes": visitors,
                    "transeuntes": passerBy,
                    "conexiones_prom": parseInt(connections[0]["sumConnection"] / cluster["stores"].length),
                    "recurrents_prom": parseInt(visitors / cluster["stores"].length),
                    "not_recurrents_prom": parseInt(passerBy / cluster["stores"].length),
                    "clicks": 0,
                    "connectionLineChart": lineChartData,
                    "periodLineChartData": connections[0]["periodArray"],
                    "revenue": "0"
                })
                if (done.length > 0){
                    this.loaded = true
                    this.loadedOffersData = true
                }
 
            })
            this.clusterData = clusterDataSet
            // this.loaded = false
            // this.loadedOffersData = true
            
        },
        getClustersOffersData: function(){
            let clusters = this.clusterArray

            let initDate = this.initRange
            let endDate = this.yesterday
            let headers = {'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'}

            let loadedCount = 0

            _.each(clusters, async(cluster, csindex) => {

                let storeRevenue = []
                let totalRevenue = 0
                let dataRevenue = 0
                let periodRevenue = []
                let revenueChartData = []
                let totalClicks = 0

                _.each(cluster.stores, async(storeValue, cindex) => {
                    // Offers
                    const offers = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/?init_date="+initDate+"&end_date="+endDate+"&store_id="+storeValue.id+"&offer_id=999999", {headers:headers})
                    _.each(offers.data, async(rvalue, i) => {
                        totalRevenue = totalRevenue + rvalue["revenue"]
                        if(cluster.stores.length==cindex+1){
                            periodRevenue.push(rvalue["period"])
                        }
                        
                        if(revenueChartData[i]!=undefined){
                            revenueChartData[i] = revenueChartData[i] + offers.data[i]["revenue"]
                        }else{
                            revenueChartData[i] = offers.data[i]["revenue"]
                        }
                    })

                    storeValue.revenue = totalRevenue.toFixed(0)
                    storeRevenue.push(totalRevenue)

                    // offers content
                    const offers_content = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/content/?init_date="+initDate+"&end_date="+endDate+"&offer_id=999999&store_id="+storeValue.id, {headers:headers})
                    
                    _.each(offers_content.data, async(clivalue, i) => {
                        totalClicks = totalClicks + clivalue["clicks"]
                    })

                    let periodContent = []
                    let clicksChartDataItems = [
                        {
                            'name': 'Interacciones',
                            'data': []
                        }
                    ]

                    let clicksChartData = []

                    let offerIds = []
                    
                    _.each(offers_content.data, async(value) => {
                        
                            if(!this.checkValue(value.period, periodContent)){
                                periodContent.push(value.period)
                            }
                    })

                    _.each(offers_content.data, async(value) => {
                        
                            if(!this.checkValue(value.offer_id, offerIds)){
                                offerIds.push(value.offer_id)
                                let click = {
                                                'name': value.offer_id,
                                                'offer_id':value.offer_id,
                                                'node_mac':value.node_mac,
                                                'data': []
                                            }
                                clicksChartData.push(click)
                            }
                    })

                    _.each(periodContent, (periodValue) => {

                        _.each(offerIds, (offerValue) => {

                            _.each(offers_content.data, (value) => {
                                
                                    if(value.period===periodValue && value.offer_id==offerValue){

                                        _.each(clicksChartData, (valuedata, index) => {

                                            if(valuedata.offer_id==value.offer_id){
                                                if(value.node_mac!==valuedata.node_mac){
                                                    clicksChartData[index].data[clicksChartData[index].data.length-1] = clicksChartData[index].data[clicksChartData[index].data.length-1] + value.clicks
                                                }else{
                                                    clicksChartData[index].data.push(value.clicks)
                                                }
                                            }
                                        })
                                    }
                            })
                        })
                    })

                    _.each(periodContent, (periodValue, indx) => {
                        let sumOffer = 0
                        _.each(clicksChartData, (valuedata, index) => {
                            _.each(valuedata.data, (value, idx) => {
                                if(indx==idx){
                                    sumOffer = sumOffer+value
                                }
                            })
                        })
                        clicksChartDataItems[0].data.push(sumOffer)
                    })

                    if (cluster.stores.length===cindex+1) {
                        cluster.revenue = 0

                        _.each(storeRevenue, (value, key) => {
                            cluster.revenue = cluster.revenue + value
                        })
                        cluster.revenue = (cluster.revenue).toFixed(0).toString()
                        
                        cluster.clicks = totalClicks

                        cluster.barChartData = clicksChartDataItems
                        cluster.periodBarChartData = periodContent

                        cluster.miliLineChartData = [{ 'data': revenueChartData, 'name': 'Conexiones' }]
                        cluster.periodMiniLineChartData = periodRevenue
                        
                        loadedCount = loadedCount +1

                        if (loadedCount===clusters.length) {
                            this.clusterArray = clusters
                            this.loadedOffersData = true
                        }
                    }
                })
            })
        },
        selectCluster: function(activecluster){
            if(activecluster!=null){
                _.each(this.clusterData, (value, i) =>{
                    if(value.name == activecluster.cluster){
                        this.clusterActive = this.clusterData[i]
                    }
                })
            }else{
                this.clusterActive = false
            }
        }
    },
    computed: {
        allStores: function(){
            var stores = this.getAllStores;
            if(this.getFilter != ""){
                stores = stores.filter(store=>this.controlStrings(store.name).includes(this.controlStrings(this.search_text)));
            }
            return stores;
        },
        allClusters: function(){
            var clusters = this.clusterArray;
            try {
                this.selectedCluster = clusters[0].name
                this.selectedClusterVenues = clusters[0].clusters   
            } catch (error) {}
            return clusters;
        },
        display: function() {
            if(window.innerWidth < 768){
                return false
            }
            return true
        },
        rangeTitle: function(){
            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
            if (this.initRange != this.yesterday) {
                return this.initRange.split('-')[2] +
                    "-" +
                    monthNames[this.initRange.split('-')[1] - 1] +
                    " al " +
                    this.yesterday.split('-')[2] +
                    "-" +
                    monthNames[this.yesterday.split('-')[1] - 1]
            }
            return this.initRange.split('-')[2] +
                    "-" +
                    monthNames[this.initRange.split('-')[1] - 1]
        },
        ...mapGetters('stores', {
            'getFilter': 'getFilter',
            'getAllStores': 'allStores',
            'getStore': 'getSelectedStore',
        }),
        ...mapGetters('clusters', {
            'getClusterFilter': 'getClusterFilter',
            'getAllClusters': 'allClusters',
            'getCluster': 'getSelectedCluster',
        }),
        todayConnectionsTitle: function (){
			let monthNames = [
				"Ene", "Feb", "Mar",
				"Abr", "May", "Jun", "Jul",
				"Ago", "Sep", "Oct",
				"Nov", "Dic"
			]
			return moment().format('DD') + "-" + monthNames[moment().format('M') - 1]
		},
    },
}
</script>

<style lang="sass">
.view.stores
    .action-header
        grid-column: 2/6
        display: flex 
        justify-content: space-between 
        margin-bottom: $sm
        @include mobile 
            grid-column: 2/4
            flex-direction: column
            button
                margin-top: $sm
        @include mobile-landscape 
            grid-column: 2/4
    .header
        grid-column: 2/6
        display: flex
        justify-content: space-between
        align-items: center
        margin-top: $sm
        @include mobile
            grid-column: 2/4
            display: none
        @include mobile-landscape
            grid-column: 2/4
    .table-card
        grid-column-start: 2
        margin-bottom: $md
        @include mobile
            display: none
        @include mobile-landscape
            display: none
        .spinner
            grid-column: 2/3
    .clustercard
        grid-column: 2/6
        @include mobile
            grid-column: 2/4
        @include mobile-landscape
            grid-column: 2/4
    .cluster-list
        grid-column: 2/6
        display: flex
        flex-wrap: wrap
        justify-content: flex-start
        align-content: flex-start
        @include mobile
            grid-column: 2/4
        .minichart
            flex-basis: 25%
            flex-grow: 0
            flex-shrink: 0
            list-style: none
            box-sizing: border-box
            border: 4px solid rgba(0,0,0,0)
            &:first-child
                border-left: none
            &:nth-child(4n+1)
                border-left: none
            &:nth-child(4n)
                border-right: none
            @include mobile
                flex-basis: 50%
                &:nth-child(2n+1)
                    border-left: none
                &:nth-child(2n)
                    border-right: none
        .section-title
            margin-bottom: $sm
            
    .fade-enter-active, .fade-leave-active 
        transition: all 0.3s
    .fade-enter, .fade-leave-to  
        opacity: 0.7
    .expand-enter-active, .expand-leave-active 
        transition: all 0.3s
    .expand-enter, .expand-leave-to  
        opacity: 0
        transform: scale(0.9)
        margin-top: 10px

</style>
